import React from 'react';
import { SpRelic, SpRelicDocument } from '../domain/relic';
import AddRelic from '../ui/AddRelic';
import Main from '../ui/Main';
import Relic from '../ui/Relic';

interface Props {
  loading: boolean;
  relics: SpRelicDocument[];
  addRelic: (relic: SpRelic) => void;
  deleteRelic: (id: string) => void;
}

function PureRelics(props: Props) {
  return <Main>
    {
      (props.loading && 'Loading relics...') || (
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
          <AddRelic onSubmit={props.addRelic}></AddRelic>
          {
            props.relics.map(relic => {
              return <Relic key={relic.$id} relic={relic} onDelete={props.deleteRelic} />
            })
          }
        </div>
      )
    }
  </Main>;
}

export default PureRelics;
